import React from "react"
import { Spin } from "antd"
import { alertPopup } from "@utils/popup"
import users from "@services/users"

class FathersName extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            edit: false,
            inputValue: ''
        }

    }

    componentDidMount() {        
        
        if (!this.props.clientInfo.fathers_name) {
            this.setState({ edit: true })
        }
        this.setState({ inputValue: this.props.clientInfo.fathers_name || '' })

    }

    handleInput = (e) => {
        let { value } = e.target
        value = value.replace(/[0-9]/, '')
        this.setState({ inputValue: value })
    }

    sendUpdate = () => {
        this.setState({ loading: true }, () => {

            const { id: user_id } = this.props.clientInfo
            const { inputValue: fathers_name } = this.state
            
            users.updateFathersName({ user_id, fathers_name })
            .then(() => {
                this.props.updateInfo()
            })
            .catch(() => {
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
            })
            .finally(() => {
                this.setState({ loading: false, edit: false })
            })

        })
    }

    render() {

        const { loading, edit, inputValue } = this.state
        const { fathers_name } = this.props.clientInfo

        return(
            <div style={{ display: 'flex' }}>
                {!edit ?
                    <div style={{ display: 'flex' }}>
                        <strong>{'שם האב: '}</strong>
                        <span
                            style={{ margin: '0 5px 0 5px', color: 'black' }}>
                                {inputValue}
                        </span>
                        <span
                            onClick={() => this.setState({ edit: true })}
                            style={{ ...styles.button }}>
                                {'עריכה'}
                        </span>
                    </div>

                    :

                    <div style={{ display: 'flex' }}>
                        <strong style={{ margin: '0 0 0 5px' }}>{'שם האב: '}</strong>
                        <input
                            value={inputValue}
                            onChange={this.handleInput}
                            style={{ ...styles.input }}
                        />
                        {loading ?
                            <Spin  style={{ margin: '5px 20px 0 0' }}/> :
                            <>
                                <span
                                    style={{ ...styles.button }}
                                    onClick={this.sendUpdate}>
                                        {'שמירה'}
                                </span>
                                {fathers_name &&
                                    <span
                                        style={{ ...styles.button }}
                                        onClick={() => this.setState({ edit: false })}>
                                            {'ביטול'}
                                    </span>}
                            </>}
                        
                    </div>}
            </div>
        )
    }
}

const styles = {
    button: {
        cursor: 'pointer',
        textDecoration: 'underline',
        margin: '0 5px 0 5px'
    },
    input: {
        height: '24px',
        outline: 'none',
        border: 'none',
        borderBottom: 'solid 1px',
        width: '100px',
        borderRadius: '3px'
    }
}

export default FathersName